import { gql } from 'apollo-angular';

export const UPDATE_EQUIPMENT_COUNTING_JOURNAL_LINE = gql`
  mutation updateEquipmentCountingJournalLine($dto: DtoUpdateEquipmentCountingJournalLine!) {
    updateEquipmentCountingJournalLine(dto: $dto) {
      id
      journalId
      equipmentId
      expectedQty
      actualQty
      variance
      status
      disposition
      notes
      actualLocationNum
      actualStation
      countedBy
      countedByName
      countedAt
      equipment {
        id
        equipmentNum
        serial
        fleetCode
        model
        make
        status
        locationNum
        station
      }
    }
  }
`;